import { render, staticRenderFns } from "./AddOrEditNewsComponent.vue?vue&type=template&id=c0e32768"
import script from "./AddOrEditNewsComponent.vue?vue&type=script&lang=js"
export * from "./AddOrEditNewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports